export const checkURL = () => {
  const hash = window.location.hash.split('?=');
  const lang = hash[0].replace('#', '');
  const category = hash[1];
  const frameRequest = hash[2];

  const storage = localStorage.getItem('language');

  let _lang, _category;


  if (lang.length) {
    if (lang === 'ka' || lang === 'en' || lang === 'ru') {
      _lang = lang;
    } else {
      _lang = storage ? storage : 'ka'
    }
  } else {
    _lang = storage ? storage : 'ka';
  }

  if (!category) {
    _category = null
  } else {
    _category = category;
  }

  return {
    language: _lang,
    category: _category,
    request: frameRequest
  }
};

export const checkLangByURL = () => {
  // const _hash = window.location.pathname.replace(/\//g, '');
  const hash = window.location.hash.split('=?');
  const lang = hash[0].replace('#', '');
  const category = hash[1];

  const storage = localStorage.getItem('language');

  if (lang.length) {
    if (lang === 'ka' || lang === 'en' || lang === 'ru') {
      return lang;
    } else {
      return storage ? storage : 'ka'
    }
  } else {
    return storage ? storage : 'ka';
  }
};
